import { Coordinate } from 'ol/coordinate'
import { GeoJSONFeature } from 'ol/format/GeoJSON'
import { Fill, Icon, Style, Text } from 'ol/style'
import React, { ReactElement, useCallback, useMemo } from 'react'

import { useClick } from '../../../features/Map/Interaction/useClick'
import { useTranslate } from '../../../features/Map/Interaction/useTranslate'
import { useVectorLayer } from '../../../features/Map/Layer/VectorLayer/useVectorLayer'
import { MapPopover } from '../../../features/Map/MapPopover'

type PinLayerProps = {
  location: {
    lat: number | string
    lng: number | string
  } | null
  onChange?: (location: {
    id: string | number
    coords: {
      lat: number
      lng: number
    }
  }) => void
  unicodeFaIcon?: string
  popover?: React.ReactElement
}

export const PinLayer = (props: PinLayerProps): ReactElement => {
  const { location, onChange, popover, unicodeFaIcon = '\uf494' } = props

  console.log('location', { location })

  const features = useMemo(() => {
    if (!location) {
      return []
    }
    return [
      {
        type: 'Feature',
        id: 1,
        geometry: {
          type: 'Point',
          coordinates: [
            parseFloat(String(location.lng)),
            parseFloat(String(location.lat)),
          ],
        },
        properties: {
          index: 0,
        },
      } as GeoJSONFeature,
    ]
  }, [location])

  const style = useMemo(() => {
    return (feature) => {
      return new Style({
        zIndex: 1,
        image: new Icon({
          color: '#276273',
          anchor: [0.15, 0.77],
          src: 'https://cdn.1st-scan.net/images/map/marker-1.png',
        }),
        text: new Text({
          text: unicodeFaIcon,
          offsetX: 10,
          offsetY: -26,
          textAlign: 'center',
          textBaseline: 'middle',
          font: "bold 14px 'Font Awesome 5 Pro'",
          fill: new Fill({
            color: 'white',
          }),
        }),
      })
    }
  }, [])

  const { layer, centerFeatures } = useVectorLayer({
    name: 'pin-layer',
    style,
    features,
    zIndex: 1,
  })

  const onTranslated = useCallback(
    ({
      id,
      coords,
    }: {
      id: string | number
      coords: {
        lat: number
        lng: number
      }
    }) => {
      if (!onChange) return
      onChange({ id, coords })
    },
    [onChange],
  )

  useTranslate({
    layer,
    onTranslated: onChange !== undefined ? onTranslated : undefined,
  })

  const onMapClick = useCallback((coordinate: Coordinate) => {
    if (!onChange) return
    onChange({
      id: 0,
      coords: {
        lat: coordinate[0],
        lng: coordinate[1],
      },
    })
  }, [])

  useClick({
    onClick: onMapClick,
  })

  React.useEffect(() => {
    setTimeout(() => {
      centerFeatures()
    }, 0)
  }, [features])

  return (
    <>
      {popover && (
        <MapPopover layer={layer} offset={[10, 0]} dimensions={[30, 40]}>
          {popover}
        </MapPopover>
      )}
    </>
  )
}
